module.exports = __webpack_public_path__ + "static/media/Payback.628c4488.png";